/**
 *
 * Notification
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useInjectReducer } from 'utils/injectReducer';
import { makeSelectNotificationState } from './selectors';
import reducer from './reducer';
import { ToastContainer, toast } from 'react-toastify';
import styled from 'styled-components';
import { NOTIFICATION as NOTIFICATION_CONSTANT } from 'common/constants';

const DefaultNotificationToaster = styled(ToastContainer)`
  .Toastify__toast {
    border-radius: 10px;
    min-height: unset;
    padding: 1rem;
    margin-bottom: 3rem;
    left: 93px;
  }
  .Toastify__toast--success {
    background-color: ${p => p.theme.palette.success};
  }
  .Toastify__toast--warning {
    background-color: ${p => p.theme.palette.warning};
  }
  .Toastify__toast--error {
    background-color: ${p => p.theme.palette.error};
  }
  .Toastify__close-button {
    align-self: unset;
  }
`;

const AgentNotificationToaster = styled(ToastContainer)`
  &&&.Toastify__toast-container {
    width: auto;
    max-width: 1154px;
    padding: 0;
    margin: 0;
    top: 3em;
    transform: translateX(-50%);
  }
  .Toastify__toast {
    display: block;
    font-family: 'Rubik';
    width: 100%;
    border-radius: 20px;
    padding: 12px 15px 11px;
    box-shadow: 0px 20px 40px 10px rgba(0, 0, 0, 0.1);
    margin: 0;
    cursor: auto;
    overflow: visible;
  }
`;

const PasswordExpireToast = styled(DefaultNotificationToaster)``;

export const Notification = props => {
  useInjectReducer({ key: 'notification', reducer });

  return (
    <>
      <DefaultNotificationToaster
        enableMultiContainer
        containerId={NOTIFICATION_CONSTANT.VARIANTS.DEFAULT}
      />
      <AgentNotificationToaster
        enableMultiContainer
        containerId={NOTIFICATION_CONSTANT.VARIANTS.AGENT_REQUEST}
      />
      <PasswordExpireToast
        enableMultiContainer
        containerId={NOTIFICATION_CONSTANT.VARIANTS.PASSWORD_EXPIRY}
      />
    </>
  );
};
Notification.propTypes = {};
export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    notification: makeSelectNotificationState(),
  });
};
export const mapDispatchToProps = dispatch => {
  return {};
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Notification);
